
import * as reducer from './reducers';

import * as subProjectsTypes from './types';
import * as subProjectsActions from './actions';
import * as subProjectsOperator from './operations';
import * as subProjectsEpics from './epics';
import * as subProjectsSelectors from './selectors';

export { subProjectsTypes, subProjectsActions, subProjectsEpics, subProjectsSelectors,subProjectsOperator };

export default reducer;

